import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsUserLoggedIn,
  selectIsUserSessionInactive,
  setUserSessionInactiveTrue,
  userLoggedInSuccess,
  userLoggedOutSuccess,
} from '../../../store/appSlice';

export interface AuthReturn {
  /**
   * Indicate whether user is logged in or not
   */
  isUserLoggedIn: boolean;
  /**
   * Indicate whether user session has expired
   */
  isUserSessionInactive: boolean;
  /**
   * Function to perform signin, it will update redux state isLoggedIn to true
   */
  signin: (callback?: () => void | undefined) => void;
  /**
   * Function to perform signout, it will update redux state isLoggedIn to false
   */
  signout: (callback?: () => void | undefined) => void;
  /**
   * Function to set redux state isSessionInactive to true
   */
  setUserSessionInactive: (callback?: () => void | undefined) => void;
}

/**
 * A hook to provide authentication functions like performing login or logout
 * @returns
 */
export const useAuth = (): AuthReturn => {
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const isUserSessionInactive = useSelector(selectIsUserSessionInactive);

  const signin = (callback?: () => void) => {
    dispatch(userLoggedInSuccess());
    if (callback) {
      callback();
    }
  };

  const signout = (callback?: () => void) => {
    dispatch(userLoggedOutSuccess());
    if (callback) {
      callback();
    }
  };

  const setUserSessionInactive = (callback?: () => void) => {
    dispatch(setUserSessionInactiveTrue());
    if (callback) {
      callback();
    }
  };

  return {
    isUserLoggedIn,
    signin,
    signout,
    isUserSessionInactive,
    setUserSessionInactive,
  };
};
